const ContractorRole = {
  CARRIER: 'CARRIER',
  CLIENT: 'CLIENT',
  INSURER: 'INSURER'
}

export default ContractorRole
